import * as React from 'react';

/**
 * Pencil SVG component
 *
 * @returns
 */
function PencilSVG(svgProps: SVGProps) {
	return (
		<svg viewBox="0 0 32 32" className={'icon icon-info ' + svgProps.class} focusable="false" aria-hidden="true">
			<path d="M27.009 0c-1.133 0-2.179 0.373-3.022 1.002l0.013-0.010-2 2 7.008 7.008 2-2c0.619-0.824 0.992-1.865 0.992-2.992 0-2.76-2.233-4.998-4.99-5.008h-0.001zM2 23.015l-2 8.985 8.992-2 18.511-18.497-7.008-7.008zM22.369 11.36l-13.993 13.993-1.729-1.729 13.993-13.993z" />
		</svg>
	);
}

export default PencilSVG;
